export default __webpack_public_path__ + "static/media/anonymous.e15246f8.svg";